export const studentQuality=  [
    {
        path: 'student-quality/attendance',
        component: () => import('@/views/studentquality/Attendance.vue')
    },
    {
        path: 'student-quality/attendance/v2',
        component: () => import('@/views/studentquality/AttendanceV2.vue')
    },
    {
        path: 'student-quality/attendance-class-v3',
        component: () => import('@/views/attendance-v2/AttendanceClassV3.vue')
    },
    {
        path: 'student-quality/attendance-group-v3',
        component: () => import('@/views/attendance-v2/AttendanceGroupV3.vue')
    },
    {
        path: 'student-quality/evaluate',
        component: () => import('@/views/studentquality/Evaluate.vue')
    },
    {
        path: 'student-quality/height-weight',
        component: () => import('@/views/studentquality/KidsHeightWeight.vue')
    },
    {
        path: 'student-quality/schedule',
        component: () => import('@/views/studentquality/Schedule.vue')
    },
    {
        path: 'student-quality/class-menu',
        component: () => import('@/views/studentquality/ClassMenu.vue')
    },
    {
        path: 'student-quality/lifecycle',
        component: () => import('@/views/studentquality/KidsLifecycle.vue')
    },
    {
        path: 'student-quality/album',
        component: () => import('@/views/album/Album.vue')
    },
    {
        path: 'student-quality/album-detail/:id',
        props: true,
        component: () => import('@/views/album/AlbumDetail.vue')
    },
    {
        path: 'student-quality/album/add',
        props: true,
        component: () => import('@/views/album/AddAlbum.vue')
    }
]
